import LtiConsumersService from "@/services/LtiConsumersService";

export default {
    state() {
        return {
            integrationKeysLTI: [],
            integrationToolsLTI: []
        }
    },

    getters: {
        getIntegrationKeysLTI: (state) => state.integrationKeysLTI,
        getIntegrationToolsLTI: (state) => state.integrationToolsLTI
    },

    mutations: {
        setIntegrationKeysLTI(state, data) {
            if (data && Array.isArray(data)) {
                state.integrationKeysLTI = data;
            }
        },

        createIntegrationKeys(state, data) {
            if (!Array.isArray(state.integrationKeysLTI) && !Array.isArray(data)) return

            state.integrationKeysLTI = [...state.integrationKeysLTI, ...data]
        },

        deleteIntegrationKeyLTI(state, integrationId) {
            if (!Array.isArray(state.integrationKeysLTI) || !integrationId) return

            const integrationIndex = state.integrationKeysLTI.findIndex((integration) => integration.id === integrationId)
            integrationIndex !== -1 && (state.integrationKeysLTI.splice(integrationIndex, 1))
        },

        setIntegrationToolsLTI(state, data) {
            if (!data || !Array.isArray(data)) return

            state.integrationToolsLTI = data
        },

        deleteIntegrationToolLTI(state, data) {
            if (!Array.isArray(state.integrationToolsLTI) || !data) return

            const integrationToolIndex = state.integrationToolsLTI.findIndex((tool) => tool.id === data)
            integrationToolIndex !== -1 && (state.integrationToolsLTI.splice(integrationToolIndex, 1))
        },

        createIntegrationTool(state, data) {
            if (!Array.isArray(state.integrationToolsLTI) || !data) return

            state.integrationToolsLTI.push(data)
        },

        updateIntegrationToolLTI(state, data) {
            if (!Array.isArray(state.integrationToolsLTI) || !data) return

            const toolIndex = state.integrationToolsLTI.findIndex((tool) => tool.id === data.id)
            toolIndex !== -1 && (state.integrationToolsLTI[toolIndex] = data)
        }
    },

    actions: {
        async getIntegrationKeysLTI({ commit, dispatch }, payload) {
            try {
                const response = await LtiConsumersService.getIntegrationKeysLTI(payload);
                commit('setIntegrationKeysLTI', response?.data);

                return response.data;
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async createIntegrationKeyLTI({ commit, dispatch }, payload) {
            try {
                const response = await LtiConsumersService.createIntegrationKeyLTI(payload.data, payload.userToken);
                commit('createIntegrationKeys', response?.data)

                dispatch('toastfy/activeSuccesNotification', { text: 'Chaves de acesso criadas com sucesso!' })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            }
        },

        async deleteIntegrationKeyLTI({ commit, dispatch }, payload) {
            try {
                await LtiConsumersService.deleteIntegrationKeyLTI(payload);
                commit('deleteIntegrationKeyLTI', payload)

                dispatch('toastfy/activeSuccesNotification', { text: 'Chave de acesso excluida com sucesso!' })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async getIntegrationToolsLTI({ commit, dispatch }, payload) {
            try {
                const response = await LtiConsumersService.getIntegrationToolsLTI(payload)
                commit('setIntegrationToolsLTI', response?.data)
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async deleteIntegrationToolLTI({ commit, dispatch }, payload) {
            try {
                LtiConsumersService.deleteIntegrationToolLTI(payload)
                commit('deleteIntegrationToolLTI', payload)

                dispatch('toastfy/activeSuccesNotification', { text: 'Ferramenta externa excluida com sucesso!' })
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
            }
        },

        async createIntegrationToolLTI({ commit, dispatch }, payload) {
            try {
                const response = await LtiConsumersService.createIntegrationToolLTI(payload)
                commit('createIntegrationTool', response?.data)

                dispatch('toastfy/activeSuccesNotification', { text: 'Ferramenta externa criada com sucesso!' })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            }
        },

        async updateIntegrationToolLTI({ commit, dispatch }, payload) {
            try {
                const response = await LtiConsumersService.updateIntegrationToolLTI(payload)
                commit('updateIntegrationToolLTI', response?.data)

                dispatch('toastfy/activeSuccesNotification', { text: 'Ferramenta externa atualizada com sucesso!' })
                return true
            } catch (error) {
                dispatch('toastfy/activeErrorNotification', { text: error })
                return false
            }
        }
    }
}